import * as React from 'react'
import type {SVGProps} from 'react'
const SvgCircleFacebookIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} viewBox="0 0 26 26" {...props}>
        <path
            d="M122.75 876h-19.5a3.255 3.255 0 0 0-3.25 3.25v19.5a3.255 3.255 0 0 0 3.25 3.25H113v-8.938h-3.25V889H113v-3.25a4.874 4.874 0 0 1 4.875-4.875h3.25v4.063H119.5c-.9 0-1.625-.085-1.625.812V889h4.063l-1.626 4.063h-2.437V902h4.875a3.255 3.255 0 0 0 3.25-3.25v-19.5a3.255 3.255 0 0 0-3.25-3.25"
            style={{
                fill: '#142745',
                fillRule: 'evenodd'
            }}
            transform="translate(-100 -876)"
        />
    </svg>
)
export default SvgCircleFacebookIcon
